const singleton = Symbol();
const singletonEnforcer = Symbol();

class SingletonModel {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer)
            throw new Error('can not construct [SingletonModel].');

        const _ = this;

        // variables
        _.modalLayers = {};
        _.isShowBodyFixedLayer = false;

        _.isEnableMouseWheel = true;

        _.pageIndexObj = {
            d1: 0
        };

        _.pages = [];
    }

    static getInstance() {
        if (!this[singleton])
            this[singleton] = new SingletonModel(singletonEnforcer);

        return this[singleton];
    }
}

export default SingletonModel;